import React, { useEffect, useState } from "react";

export default function ChatWindow(props) {

    const [clsname, setClsname] = useState("chatwindow-container hide");
    const [isOpen, toggleIsOpen] = useState(false);

    const closeChat = () => {
        if (isOpen) {
            toggleIsOpen(false)
            setClsname("chatwindow-container hide")
        }
        else {
            toggleIsOpen(true)
            setClsname("chatwindow-container show")
        }
    }

    useEffect(() => {
        let mounted = true;
        if (isOpen) {
            setClsname("chatwindow-container show")
        }
        else {
            setClsname("chatwindow-container hide")
        }
        return () => mounted = false;
    }, [isOpen]);

    return (
        <div className={clsname}>
            <span className="close-chat" onClick={closeChat} title="Support chat">
                <i className={`fa fa-lg ${isOpen ? 'fa-times' : 'fa-comment'}`} style={{ color: "white" }}></i>
            </span>
            <iframe
                src={process.env.REACT_APP_BUILD_ENV === 'production' || process.env.REACT_APP_BUILD_ENV === 'development'
                    ? 'https://agent.timologic.gr'
                    : 'https://agent.timologic.gr'}
                style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
            />
        </div>
    );
}
